(function () {
  // data class that does all maths and mechanics for a slotmachine reel. Does not have dependencies on any libs including Pixi or Reflex libs
  // the one exception being the state machine in Reflex libs. But thats ok because I like that class!
  class DynamicReelSpinnerData {
    constructor(
      reelId,
      maxAppertureHeight,
      symbolSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      nudgeReel
    ) {
      this._reelId = reelId;
      this._reelIdIndex = parseInt(reelId.replace("reel", ""));
      // _reelId is a string ("reel0", "reel1" etc) and _reelIdIndex is the number (0, 1 etc). Look at removing reelId.
      this._dynamicInjector = false;
      this._maxAppertureHeight = maxAppertureHeight; // how many symbols will maximum will be in the window. In a 5x3 game this is 3
      this._currentAppertureHeight = this._maxAppertureHeight; // default to max. This is used for MegaWays
      this._preAppertureSymbols = numPreapp; // how many extra symbols need to be created to for mid spins
      this._postAppertureSymbols = numPostapp;
      this._totalAppertureSize =
        this._maxAppertureHeight +
        this._preAppertureSymbols +
        this._postAppertureSymbols;
      this._spinModes = {}; // map of all available spin modes
      this._symbolData = [];
      this._savedSymbolData = [];
      this._symbolSpacingDefault = symbolSpacing;
      this._minSymbolSpacing = symbolSpacing;
      this._postOffset = 0;
      this._deltaTime = 0; // all spin movement is based on time to travel 1 symbol
      this._sDelta = 0; // Using seconds, need a scaled delta
      this._slamStopReels = false;
      this._spinTime = 0; // Remove this later
      this._onLandCallback = undefined;
      this._onHitCallback = undefined;
      this._onNewSymbolCallback = undefined;
      this._onOldSymbolRemovedCallback = undefined;
      this._reservedSpace = reservedSpace;
      this._abortSymbols = [];
      this._runningUniqueId = 0;
      this._reelSpinning = false;
      this._runningDelta = 0;
      this._aborted = false;
      this._isSpinning = false;
      this._frameCount = 0;
      this._bouncing = false;
      this._bounceDownTime = 0;
      this._bounceUpTime = 0;
      this._currentSymbolOffset = 0;
      this.sc_LandOffset = 0;
      this.sc_LastSpinOffset = 0;
      this.sc_NudgeThisSpin = false;
      this._nudgeReel = nudgeReel;
      this.literalReelPosition = 0;
      this.oldLiteralReelPosition = 0;
      this.literalDistanceAtEndOfPreviousPhase = 0;
      this.symbolsToSpinAfterResults = 0;
      this._spinPhaseList = [];
      this._newSymbols = 0;
      this._tempReelBand = [];
      this._tempReelBandIndex = 0;
      this._tempReelBandLandSymbols = [];
      this._tempReelBandStartingIndex = 0;
      this._mainBandBackup = [];

      this._defaultReelParameters = {
        reverse: false,
        symbolsPerSecond: 20,
        decelerationDistance: 0,
        bounceDistance: 0,
        bounceTime: 0,
      };
      for (let i = 0; i < this._totalAppertureSize; ++i) {
        this._symbolData.push({
          symId: 0,
          yPos: 0,
          appertureHeight: this._currentAppertureHeight,
          uniqueId: this._runningUniqueId++,
          overlayData: {},
        }); // pre/post-apperature symbols are the last symbols here. Index 0 is top of visible window
      }

      this._preAppertureSymbolIdx = this._maxAppertureHeight; // the start of the preapperture symbols are just below the window symbols in the list
      this._postAppertureSymbolIdx = this._preAppertureSymbolIdx + numPreapp; // the start of the postpperture symbols are just below the preappature symbols in the list
      this._bottomPreAppertureSymbolIdx = this._postAppertureSymbolIdx - 1; // when working with preapperture symbol it is really useful to work with the one directly above the window symbols

      // Symbols are organised in a strange way, see comments in ReelSpinnerData.js for details
      // Should be preapperture symbols, window symbols, postapperture symbols
      this._symbolOrdering = [];
      for (let i = 0; i < this._totalAppertureSize; ++i) {
        if (
          i < this._preAppertureSymbolIdx ||
          i >= this._postAppertureSymbolIdx
        ) {
          this._symbolOrdering.push(i);
        }
      }
      for (
        let i = this._postAppertureSymbolIdx - 1;
        i >= this._preAppertureSymbolIdx;
        --i
      ) {
        this._symbolOrdering.unshift(i);
      }

      this.setReelParameters({});
      this.createStates();
    }

    onLayoutComplete() {
      this.refreshPos();
    }

    createStates() {
      StateMachine.Create(this);
      let self = this;

      this.stateMachine.addState("IDLE", function () {
        self.state_idle();
      });
      this.stateMachine.addState("NUDGE", function () {
        self.state_nudge();
      });
      this.stateMachine.addState("DYNAMIC_SPIN", function () {
        self.state_dynamic_spin();
      });
    }

    //////////////////////////
    // MAIN SPIN FLOW START //
    ////////////////////////////////////////////////////////////////////////////////
    // Phase 1 - Told to spin and provided with a spin config with spin parameters
    startDynamicSpin(callbackNewSymbol, callbackOldSymbol, spinConfig) {
      this._newSymbols = 0;
      this.setupSpinConfig(spinConfig);

      this._dynamicInjector.setStartSpinPosition();
      this._tempReelBandStartingIndex = this._tempReelBandIndex;
      this._runningDelta = 0;
      this.saveInjectorsState();
      this.saveSymbolData();
      this._reelSpinning = true;
      this._slamStopReels = false;
      this._onNewSymbolCallback = callbackNewSymbol;
      this._onOldSymbolRemovedCallback = callbackOldSymbol;
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Phase 2 - Use the spin config to setup initial spin data
    setupSpinConfig(spinConfig) {
      // Jamie finding a better way to do this so you don't have to copy over spin config
      // settings to land config if undefined
      this.spinConfig = spinConfig;

      // If no data for reel, do not spin
      if (this.spinConfig[this._reelId] === undefined) {
        return;
      }

      // Jamie - add defaults and backup spin config details here
      this.sc_StartDelay = spinConfig[this._reelId].startDelay;
      this.sc_ReelStartDelayOffset =
        spinConfig[this._reelId].reelStartDelayOffset;

      this.sc_PullbackTime = spinConfig[this._reelId].pullbackTime;
      let pullbackAmount = spinConfig[this._reelId].pullbackAmount; // Jamie - clamp this between 0 and 1
      this.sc_PullbackDistance = pullbackAmount * this._minSymbolSpacing;
      let pullbackStrength = spinConfig[this._reelId].pullbackStrength;
      this.sc_PullbackStrength = this.clamp(pullbackStrength, 1, 10);

      // Jamie - have a better system dealing with undefined values
      if (this.sc_PullbackTime === undefined || isNaN(this.sc_PullbackTime)) {
        this.sc_PullbackTime = 0;
      }
      if (
        this.sc_PullbackDistance === undefined ||
        isNaN(this.sc_PullbackDistance)
      ) {
        this.sc_PullbackDistance = 0;
      }
      if (
        this.sc_PullbackStrength === undefined ||
        isNaN(this.sc_PullbackStrength)
      ) {
        this.sc_PullbackStrength = 1;
      }

      this.sc_AccelerationTime = spinConfig[this._reelId].accelerationTime;
      let accStrength = spinConfig[this._reelId].accelerationStrength;
      this.sc_AccelerationStrength = this.clamp(accStrength, 1, 10);

      this.sc_MainReelSpinTime = spinConfig[this._reelId].mainReelSpinTime;
      this.sc_MainReelSpinTimeReelOffset =
        spinConfig[this._reelId].mainReelSpinTimeReelOffset;
      this.sc_SymbolsPerSecond = spinConfig[this._reelId].symbolsPerSecond;
      this.sc_MainSpinSpeedPerSecond =
        this.sc_SymbolsPerSecond * this._minSymbolSpacing;

      this.sc_DecelerationTime = spinConfig[this._reelId].decelerationTime;
      let decStrength = spinConfig[this._reelId].decelerationStrength;
      this.sc_DecelerationStrength = this.clamp(decStrength, 1, 10);

      this.sc_BounceTime = spinConfig[this._reelId].bounceTime;
      this.sc_BounceAmount = spinConfig[this._reelId].bounceAmount;

      this.setupSpinStates();
    }

    /////////////////////////////////////////////////////////////////////////////////////
    // Phase 3 - Setup the spin state machine. Only includes the states that are needed
    setupSpinStates() {
      // 1 = Start Delay
      // 2 = Reel Index Delay
      // 3 = Pullback
      // 4 = Acceleration
      // 5 = Main Spin
      // 6 = Deceleration
      // 7 = Bounce
      // 8 = Spin Complete
      this._spinPhaseList = [];

      //////////////////////////////////////////////////////////////////////////////////
      // Start Delay
      if (this.sc_StartDelay > 0) {
        this._spinPhaseList.push(1);
      }
      //////////////////////////////////////////////////////////////////////////////////
      // Reel Index Delay
      if (this.sc_ReelStartDelayOffset > 0) {
        this._spinPhaseList.push(2);
      }
      //////////////////////////////////////////////////////////////////////////////////
      // Pullback
      if (this.sc_PullbackTime > 0 && this.sc_PullbackDistance > 0) {
        this._spinPhaseList.push(3);
      }
      //////////////////////////////////////////////////////////////////////////////////
      // Acceleration
      if (this.sc_AccelerationTime > 0) {
        this._spinPhaseList.push(4);

        // Seeing as we know here that we have an acceleration phase, we can calculate the acceleration distance
        this.sc_TotalAccelerationDistance = this.calculatePhaseDistance(
          this.sc_AccelerationStrength,
          this.sc_MainSpinSpeedPerSecond,
          this.sc_AccelerationTime
        );
      }
      //////////////////////////////////////////////////////////////////////////////////
      // Main Spin
      this._spinPhaseList.push(5);
      //////////////////////////////////////////////////////////////////////////////////
      // Deceleration
      if (this.sc_DecelerationTime > 0) {
        this._spinPhaseList.push(6);
      }
      //////////////////////////////////////////////////////////////////////////////////
      // Bounce
      if (this.sc_BounceTime > 0 && this.sc_BounceAmount > 0) {
        this._spinPhaseList.push(7);
      }
      //////////////////////////////////////////////////////////////////////////////////
      // Spin Complete
      this._spinPhaseList.push(8);
      //////////////////////////////////////////////////////////////////////////////////

      this.currentSpinPhaseID = 0;
      this.currentPhaseTime = 0; // Might remove

      this.spinComplete = false;
      this.spinFinalised = false;
      this.reelSpinTimer = 0.0;
      this.stateMachine.switchState("DYNAMIC_SPIN");
    }

    /////////////////////////////////////////////////////////////////////////////////////
    // Phase 4 - We're spinning!!!
    state_dynamic_spin() {
      if (this.phase.hold()) {
        // If statements used so we fall into the next state immediately after the previous one
        // Current built-in state machine doesn't allow for this and has dropped update frames
        if (this.currentSpinPhaseID === 0) {
          this.spin_phase_setup(); // Setup values used across the spin - included here so no frames missed
        }
        if (this.currentSpinPhaseID === 1) {
          this.spin_phase_start_delay();
        }
        if (this.currentSpinPhaseID === 2) {
          this.spin_phase_reel_index_delay();
        }
        if (this.currentSpinPhaseID === 3) {
          this.spin_phase_pullback();
        }
        if (this.currentSpinPhaseID === 4) {
          this.spin_phase_acceleration();
        }
        if (this.currentSpinPhaseID === 5) {
          this.spin_phase_main_spin();
        }
        if (this.currentSpinPhaseID === 6) {
          this.spin_phase_deceleration();
        }
        if (this.currentSpinPhaseID === 7) {
          if (this._onHitCallback) {
            this._onHitCallback(this._reelId);
            this._onHitCallback = undefined;
          }
          this.spin_phase_bounce();
        }
        if (this.currentSpinPhaseID === 8) {
          this.spin_phase_spin_complete();
        }
        if (this.spinComplete) {
          this.phase.step();
        }
      }
      if (this.phase.once()) {
        this._dynamicInjector.clearLandingSymbols();
        this.stateMachine.switchState("IDLE");
      }
      if (this.phase.exit()) {
        this.displayFinalPositions();
        this._slamStopReels = false;
        this._reelSpinning = false;
        this._bouncing = false;
      }
    }

    /////////////////////////////////////////////////////////////////////////////////////
    // Phase 5 - Complete list of spin phases the reels will go through
    spin_phase_setup() {
      // Add the offset (nudge pos) to reel start position and reset the offset
      this.literalReelPosition = this._currentSymbolOffset;
      this.oldLiteralReelPosition = 0;
      this._currentSymbolOffset = 0;

      this.refreshPos();
      this.gotoNextSpinPhase();
    }

    spin_phase_start_delay() {
      this.currentPhaseTime += this._sDelta;

      if (this.currentPhaseTime >= this.sc_StartDelay) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_reel_index_delay() {
      this.currentPhaseTime += this._sDelta;

      if (this.currentPhaseTime >= this.sc_ReelStartDelayOffset) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_pullback() {
      this.currentPhaseTime += this._sDelta;
      let progress = this.currentPhaseTime / this.sc_PullbackTime;

      let easeValue = this.customEaseIn(progress, this.sc_PullbackStrength);
      let distance = easeValue * this.sc_PullbackDistance;
      this.literalReelPosition =
        this.literalDistanceAtEndOfPreviousPhase - distance;
      this.refreshPos();

      if (this.currentPhaseTime >= this.sc_PullbackTime) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_acceleration() {
      this.currentPhaseTime += this._sDelta;
      let progress = this.currentPhaseTime / this.sc_AccelerationTime;

      let easeValue = this.customEaseIn(progress, this.sc_AccelerationStrength);
      let distance = easeValue * this.sc_TotalAccelerationDistance;
      this.literalReelPosition =
        this.literalDistanceAtEndOfPreviousPhase + distance;
      this.refreshPos();

      if (this.currentPhaseTime >= this.sc_AccelerationTime) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_main_spin() {
      this.literalReelPosition +=
        this._minSymbolSpacing * this.sc_SymbolsPerSecond * this._sDelta;
      this.refreshPos();

      if (this.reelSpinTimer < this.sc_MainReelSpinTime && this.spinFinalised) {
        // This effectively pauses the reel spin timer if the results haven't come through yet
        this.reelSpinTimer += this._sDelta;
      }

      // If we don't have the landing symbols yet, we need to keep spinning
      // JAMIE - ALSO NEED TO CHECK WE HAVE A CLEAR PATH TO THE LANDING SYMBOLS OBAYING ALL SYMBOL RULES
      if (
        this.reelSpinTimer >= this.sc_MainReelSpinTime &&
        this.spinFinalised
      ) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_deceleration() {
      this.currentPhaseTime += this._sDelta;
      let progress = this.currentPhaseTime / this.sc_DecelerationTime;

      let easeValue = this.customEaseOut(
        progress,
        this.sc_DecelerationStrength
      );
      let distance = easeValue * this.sc_TotalDecelerationDistance;
      this.literalReelPosition =
        this.literalDistanceAtEndOfPreviousPhase + distance;

      this.refreshPos();

      if (this.currentPhaseTime >= this.sc_DecelerationTime) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_bounce() {
      this.currentPhaseTime += this._sDelta;
      let progress = this.currentPhaseTime / this.sc_BounceTime;

      let easeValue = this.customEaseIn(progress, 1);
      let distance = easeValue * this.sc_BounceAmount;
      this.literalReelPosition =
        this.literalDistanceAtEndOfPreviousPhase - distance;
      this.refreshPos();

      if (this.currentPhaseTime >= this.sc_BounceTime) {
        this.gotoNextSpinPhase();
      }
    }

    spin_phase_spin_complete() {
      this.refreshPos();
      this.spinComplete = true;
      this.gotoNextSpinPhase();
    }

    /////////////////////////////////////////////////////////////////////////////////////
    // Phase 5b - Need to do a little setup when transitioning states
    gotoNextSpinPhase() {
      if (this._spinPhaseList.length === 0) {
        return;
      }

      this.currentPhaseTime = 0;
      this.literalDistanceAtEndOfPreviousPhase = this.literalReelPosition;

      this.currentSpinPhaseID = this._spinPhaseList.shift();

      // This is a hack to get the reels to land pixel perfect in the correct position
      // There isn't much we can do about this unfortunately, we have precalculated the
      // deceleration distance to get the final land position but we can't guarantee that
      // exact distance will land pixel perfect just due to the nature of timer updates
      // This will only shift by a few pixels at most
      if (this.currentSpinPhaseID === 6) {
        this.sc_TotalDecelerationDistance =
          this.finalTotalSpinDistance - this.literalReelPosition;

        // We also need to apply our land offsets here
        this.sc_TotalDecelerationDistance +=
          this.sc_LandOffset + this.sc_BounceAmount;
      }
    }

    /////////////////////////////////////////////////////////////////////////////////////
    // Phase XX1 - The following can occur at any time during the spin
    // Depends on when the results are sent through and the game
    // giving the spinner permission to land using stopReels() in gameController
    landReel(callback, hitCallback, landConfig) {
      this._spinTime = 0;
      this._onLandCallback = callback;
      this._onHitCallback = hitCallback;

      if (this.spinConfig[this._reelId] !== undefined) {
        this.setupLandConfig(landConfig);
      }
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Phase XX2 - Obtain new spin parameters from the land config
    // Once results are known, we can adjust the spin parameters
    // for anticipation spins, reel modifiers etc
    // PS... I know these undefined checks are bad, but I haven't yet decided how
    // the game should provide these config values
    setupLandConfig(landConfig) {
      this.sc_MainReelSpinExtension =
        landConfig[this._reelId].mainReelSpinExtension;
      if (
        this.sc_MainReelSpinExtension === undefined ||
        isNaN(this.sc_MainReelSpinExtension)
      ) {
        this.sc_MainReelSpinExtension = 0;
      }

      this.sc_DecelerationTime = landConfig[this._reelId].decelerationTime;
      if (
        this.sc_DecelerationTime === undefined ||
        isNaN(this.sc_DecelerationTime)
      ) {
        this.sc_DecelerationTime =
          this.spinConfig[this._reelId].decelerationTime;
      }
      let decStrength = landConfig[this._reelId].decelerationStrength;
      // Jamie - handle clamping better - does it in two places
      // Do we want less severe clamping for anticipation spins?????
      this.sc_DecelerationStrength = this.clamp(decStrength, 1, 10);
      if (
        this.sc_DecelerationStrength === undefined ||
        isNaN(this.sc_DecelerationStrength)
      ) {
        this.sc_DecelerationStrength =
          this.spinConfig[this._reelId].decelerationStrength;
      }

      this.sc_BounceTime = landConfig[this._reelId].bounceTime;
      if (this.sc_BounceTime === undefined || isNaN(this.sc_BounceTime)) {
        this.sc_BounceTime = this.spinConfig[this._reelId].bounceTime;
      }
      this.sc_BounceAmount = landConfig[this._reelId].bounceAmount;
      if (this.sc_BounceAmount === undefined || isNaN(this.sc_BounceAmount)) {
        this.sc_BounceAmount = this.spinConfig[this._reelId].bounceAmount;
      }

      let landOffset = landConfig[this._reelId].landOffset;
      if (landOffset === undefined || isNaN(landOffset)) {
        landOffset = 0;
      } else {
        landOffset = this.clamp(
          landOffset,
          -this._minSymbolSpacing,
          this._minSymbolSpacing
        );
      }

      this.sc_LandOffset = landOffset;

      let nudgeThisSpin = landConfig[this._reelId].nudgeThisSpin;
      if (nudgeThisSpin === undefined || isNaN(nudgeThisSpin)) {
        this.sc_NudgeThisSpin = false;
      } else {
        this.sc_NudgeThisSpin = nudgeThisSpin;
      }

      this.adjustSpinParameters();
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Phase XX3 - Use the land config data to adjust main spin and deceleration phases
    adjustSpinParameters() {
      // Firstly - add the reel offset time to the main spin time
      // This is the value to ensure reels land staggered
      this.sc_MainReelSpinTime += this.sc_MainReelSpinTimeReelOffset;
      // Secondly - add the extension time to the main spin time
      // This is the value that may be added for anticipation spins
      this.sc_MainReelSpinTime += this.sc_MainReelSpinExtension;
      // New deceleration time/strength and bounce parameters already set

      this.finaliseSpin();
    }

    ////////////////////////////////////////////////////////////////////////////////
    // Phase XX4 - Finalise the spin!!
    // Results are in, game has given the go ahead to land
    // Calculate the exact distance to travel and land the symbols
    // So we can place the symbols in the correct position
    finaliseSpin() {
      // Calculate the exact pixel distance to travel during the remaining main spin phase

      let totalMainSpinDistance =
        this._minSymbolSpacing *
        this.sc_SymbolsPerSecond *
        this.sc_MainReelSpinTime;

      // Make sure to add symbols already spun to total distance
      totalMainSpinDistance += this._newSymbols * this._minSymbolSpacing;

      let preDecelerationDistance =
        this.sc_TotalAccelerationDistance + totalMainSpinDistance;

      let decelerationDistance = this.calculatePhaseDistance(
        this.sc_DecelerationStrength,
        this.sc_MainSpinSpeedPerSecond,
        this.sc_DecelerationTime
      );

      let projectedTotalSpinDistance =
        preDecelerationDistance + decelerationDistance;
      let symbolOffsetRemainder =
        projectedTotalSpinDistance % this._minSymbolSpacing;
      this.sc_TotalDecelerationDistance =
        decelerationDistance - symbolOffsetRemainder;
      this.finalTotalSpinDistance =
        preDecelerationDistance + this.sc_TotalDecelerationDistance;

      this.symbolsToSpinAfterResults = Math.round(
        this.finalTotalSpinDistance / this._minSymbolSpacing
      );

      if (this._tempReelBandLandSymbols.length > 0) {
        this.insertTempReelBandLandSymbols(this.symbolsToSpinAfterResults);
        this._dynamicInjector.setReadyToLand(true);
      } else {
        this._dynamicInjector.insertLandingSymbols(
          this.symbolsToSpinAfterResults
        );
      }

      this.spinFinalised = true;
    }
    //////////////////////////
    // MAIN SPIN FLOW END ////
    //////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////

    // Used to calculate the pixel distance spun prior to
    // acceleration and deceleration phases
    calculatePhaseDistance(strength, mainSpeedPerSecond, phaseTime) {
      if (strength === 0) {
        return 0;
      }
      let distanceScaler = 1 / strength;
      return mainSpeedPerSecond * phaseTime * distanceScaler;
    }

    refreshPos() {
      let refreshDistanceUpdate =
        this.literalReelPosition - this.oldLiteralReelPosition;
      this.oldLiteralReelPosition = this.literalReelPosition;
      this._currentSymbolOffset += refreshDistanceUpdate;

      // JAMIE - This will need adjusting later. Cannot assume all symbols are the same height, I.e. megaways
      if (this._currentSymbolOffset >= this._minSymbolSpacing) {
        this._currentSymbolOffset -= this._minSymbolSpacing;
        this.copySymbolIdsToNextSymbol();
      }

      this.updateSymbolPositions();
    }

    copySymbolIdsToNextSymbol() {
      if (this._onOldSymbolRemovedCallback) {
        this._onOldSymbolRemovedCallback(
          this._reelId,
          this._symbolData[this._maxAppertureHeight - 1],
          this._maxAppertureHeight - 1
        );
      }

      for (let i = this._symbolData.length - 1; i > 0; --i) {
        let curIndex = this._symbolOrdering[i];
        let prevIndex = this._symbolOrdering[i - 1];
        this._symbolData[curIndex].symId = this._symbolData[prevIndex].symId;
        this._symbolData[curIndex].overlayData =
          this._symbolData[prevIndex].overlayData;
        this._symbolData[curIndex].uniqueId =
          this._symbolData[prevIndex].uniqueId;
        this._symbolData[curIndex].appertureHeight =
          this._symbolData[prevIndex].appertureHeight;
        // Jamie - again this will have to get actual symbol height for megaways
        this._symbolData[curIndex].yPos -= this._minSymbolSpacing;
      }

      let nextSymbolID = 0;

      if (this._tempReelBand.length >= this._totalAppertureSize) {
        this._tempReelBandIndex++;
        while (this._tempReelBandIndex >= this._tempReelBand.length) {
          this._tempReelBandIndex -= this._tempReelBand.length;
        }
        nextSymbolID = this._tempReelBand[this._tempReelBandIndex];
      } else {
        nextSymbolID = this._dynamicInjector.getNextReelBandSymbol();
      }
      this._newSymbols++;

      let topIndex = this._symbolOrdering[0];
      this._symbolData[topIndex].symId = nextSymbolID; // get a new symbol from injector
      this._symbolData[topIndex].uniqueId = this._runningUniqueId++;
      this._symbolData[topIndex].appertureHeight = this._currentAppertureHeight;
      this._symbolData[topIndex].overlayData = {};
    }

    updateSymbolPositions() {
      if (this._onNewSymbolCallback) {
        this._onNewSymbolCallback(
          this._reelId,
          this._symbolData[this._preAppertureSymbolIdx],
          this._preAppertureSymbolIdx
        );
      }

      for (let i = 0; i < this._symbolData.length; ++i) {
        let curIndex = this._symbolOrdering[i];
        this._symbolData[curIndex].yPos =
          this._currentSymbolOffset +
          i * this._minSymbolSpacing -
          2 * this._minSymbolSpacing;

        this._symbolData[curIndex].yPos += this._postOffset;
      }
    }

    slamStop() {
      if (this._dynamicInjector.readyToLand()) {
        this._slamStopReels = true;
        this.displayFinalPositions();
      }
    }

    displayFinalPositions() {
      if (!this._dynamicInjector.readyToLand()) {
        console.log("Cannot land yet " + this._reelId + " results not in");
        return false;
      }

      if (this._slamStopReels) {
        // Jamie - only do this for slam stop for now
        // Might not want to go to idle if we have a bounce
        this.stateMachine.switchState("IDLE");

        while (!this._dynamicInjector.reachedLandingSymbols()) {
          this.copySymbolIdsToNextSymbol();
        }
        this._slamStopReels = false;
      }

      // check symbolData against what we have to display
      // had a weird issue in devils where the final symbols shown could be incorrect
      // cpu low tier along with tab switching and rotating outside the tab could end up
      // with the game showing wrong symbols
      // this is a fail safe to make sure the reels show the right symbol
      for (let i = 0; i < this._landSymbols.length; i++) {
        if (this._symbolData[i].symId != this._landSymbols[i]) {
          console.log(
            `WARNING: final symbol different on reel${this._reelIdIndex} row${i} - should be ${this._landSymbols[i]} was ${this._symbolData[i].symId}`
          );
          this._symbolData[i].symId = this._landSymbols[i];
        }
      }

      this.literalReelPosition = 0;
      this.oldLiteralReelPosition = 0;
      // We have already added the land offset to the final distance, but here if the value is outside
      // the range of one symbols size, we need to wrap it around
      // IMPORTANT - Land Offset should NOT be reset between spins, as if the reels start offset, they will
      // need to add the new offset to the previous offset
      let landOffset = this.wrapValue(
        this.sc_LandOffset,
        this._minSymbolSpacing
      );
      this.sc_LastSpinOffset = landOffset;
      this._currentSymbolOffset = landOffset;
      this.refreshPos();

      if (this._onHitCallback) {
        this._onHitCallback(this._reelId);
        this._onHitCallback = undefined;
      }

      if (this._onLandCallback) {
        this._onLandCallback(this._reelId);
        this._onLandCallback = undefined;
      }
    }

    update(delta) {
      this._frameCount++;
      this._deltaTime = delta;
      this._sDelta = delta / 1000;
      this._runningDelta += delta;
      this.stateMachine.update();
    }

    nudgeReel(time) {
      this.currentPhaseTime = 0;
      this.nu_NudgeTime = time;
      this.nu_NudgeDistance = this.sc_LandOffset;

      // This is a pain, but symbols can nudge in both directions
      // Just want to move the symbols back to where they
      // would have originally have landed
      this.symbolYPositions = [];
      for (let i = 0; i < this._symbolData.length; ++i) {
        this.symbolYPositions.push(this._symbolData[i].yPos);
      }

      this.stateMachine.switchState("NUDGE");
    }

    state_idle() {
      if (this.phase.enter()) {
        this._aborted = false;
        this._isSpinning = false;
        this._bouncing = false;
      }
      if (this.phase.exit()) {
        this._isSpinning = true;
      }
    }

    // Nudging done as a separate state
    state_nudge() {
      if (this.phase.hold()) {
        this.currentPhaseTime += this._sDelta;
        let progress = this.currentPhaseTime / this.nu_NudgeTime;
        let easingValue = this.nudgeEasing(progress);
        let distance = easingValue * this.nu_NudgeDistance;

        // I hate this system!! Hack to get round stupid symbol update
        // I just want to move a damn graphic!!
        for (let i = 0; i < this._symbolData.length; ++i) {
          this._symbolData[i].yPos = this.symbolYPositions[i] - distance;
        }

        if (this.currentPhaseTime >= this.nu_NudgeTime) {
          this.phase.step();
        }
      }
      if (this.phase.once()) {
        for (let i = 0; i < this._symbolData.length; ++i) {
          this._symbolData[i].yPos =
            this.symbolYPositions[i] - this.nu_NudgeDistance;
        }

        this.literalReelPosition = 0;
        this.oldLiteralReelPosition = 0;
        this._currentSymbolOffset = 0;

        if (this.nu_NudgeDistance < 0) {
          // Slight hack, if we nudge symbol down, we need to force a symbol update
          this._currentSymbolOffset = this._minSymbolSpacing;
        }
        this.refreshPos();

        this.sc_LandOffset = 0;
        this.sc_LastSpinOffset = 0;
        this.stateMachine.switchState("IDLE");
      }
    }

    /////////////////////////////////////////////////////////////////////////////////////

    loadInjector(symbolWeightings, symbolRules) {
      let symbolsStillInWindow = this.getSymbolsStillInWindow(true);
      this._dynamicInjector = new DynamicInjector();
      this._dynamicInjector.prepareInjector(
        this._reelIdIndex,
        symbolsStillInWindow,
        this._nudgeReel,
        this._postAppertureSymbolIdx,
        symbolWeightings,
        symbolRules
      );

      for (let i = 0; i < this._totalAppertureSize; ++i) {
        if (i >= this._maxAppertureHeight) {
          let safeSym = this._dynamicInjector.getSafeSymbol();
          this._symbolData[i].symId = safeSym;
        }
      }
    }

    setLandingSymbols(landSymbols, aboveSymbols = [], belowSymbols = []) {
      this._landSymbols = landSymbols.slice(0);
      this._dynamicInjector.setLandingSymbols(
        landSymbols,
        aboveSymbols,
        belowSymbols
      );
    }

    setLogger(logger) {
      this.logger = logger;
    }

    getCurrentSymbolsPerSecond() {
      return this._reelParameters.symbolsPerSecond;
    }

    //returns the height of a symbol taken into account its dynamic appertureHeight (megaways)
    getSymbolHeight(symbolIndex) {
      return (
        (this._maxAppertureHeight /
          this._symbolData[symbolIndex].appertureHeight) *
        this._minSymbolSpacing
      );
    }

    getTotalAppertureSize() {
      return this._totalAppertureSize;
    }

    getMaxSymbolsInWindow() {
      return this._maxAppertureHeight;
    }

    getPreappertureSymbols() {
      // badly named function, returns the number of them, and not the actual symbols
      return this._preAppertureSymbols;
    }

    getPostappertureSymbols() {
      // badly named function, returns the number of them, and not the actual symbols
      return this._postAppertureSymbols;
    }

    getInjectors() {
      return this._dynamicInjector;
    }

    getSymbolData() {
      return this._symbolData;
    }

    getCurrentAppertureHeight() {
      return this._currentAppertureHeight;
    }

    getSymbolAppertureHeight(symbolId) {
      return this._symbolData[symbolId].appertureHeight;
    }

    // this is to make sure that the dynamic symbols have enough space between source and target bands
    // to fit a symbol. I.E. a gigablox symbol might be 3x3, meaning that one symbol requires 3 vertical space
    // if the space provided for dynamic symbols do not fit full blocks then we will get slicing of symbols
    getReservedSpace() {
      return this._reservedSpace;
    }

    clamp(num, min, max) {
      return num <= min ? min : num >= max ? max : num;
    }

    wrapValue(value, range) {
      if (range !== 0) {
        value = value % range;
        if (value < 0) {
          value += range;
        }
        return value;
      } else {
        return 0;
      }
    }

    getRatioOfPreappertureSymbolInView(reverseSpin) {
      let symbolHeight = this.getSymbolHeight(
        this._bottomPreAppertureSymbolIdx
      );
      let symbolYPos = this._symbolData[this._bottomPreAppertureSymbolIdx].yPos;

      if (!reverseSpin) {
        let res = (symbolYPos + symbolHeight) / symbolHeight; // as the end position is 0, i.e. fully in view, this works. Wont work for reverse
        return this.clamp(res, 0, 1);
      } else {
        let windowHeight = this._maxAppertureHeight * this._minSymbolSpacing;
        symbolYPos -= windowHeight;
        let res = symbolYPos / symbolHeight;
        return this.clamp(res, 0, 1);
      }
    }

    setReelSymbol(index, symbolId) {
      if (index < this._totalAppertureSize) {
        this._symbolData[index].symId = symbolId;
        this._symbolData[index].uniqueId = this._runningUniqueId++;
      } else {
        console.error(
          "Trying to set a reel symbol greater than window size of "
        );
      }
    }

    setInjectors(preInjector, postInjector) {
      // No longer set by slot machine because that's awful!!!
      // Still need this function though and getInjectors
      // Remove when slot machine is refactored
    }

    // chane the number of symbols that fit fully in the window
    setAppertureHeight(numInWindow) {
      this._currentAppertureHeight = numInWindow;
    }

    setReelParameters(params) {
      this._reelParameters = Object.assign(this._defaultReelParameters, params);
      //this.updateSymbolPositions(); // this will move the preapperture symbol to bottom if reverse is set, otherwise code will think the preapperture symbol has moved a position
    }

    // MIKE should include reverse
    getSymbolsStillInWindow(includeTopMostPreApp) {
      let symbolsStillInWindow = [];
      //symbolsStillInWindow are bottom up
      // add post app

      for (let i = 0; i < this._postAppertureSymbols; ++i) {
        let idx = this._symbolData.length - 1 - i;
        symbolsStillInWindow.push(this._symbolData[idx].symId);
      }
      // add window
      for (let i = this._maxAppertureHeight - 1; i >= 0; --i) {
        symbolsStillInWindow.push(this._symbolData[i].symId);
      }

      // add pre app
      let numberOfPreapp = includeTopMostPreApp
        ? this._preAppertureSymbols
        : this._preAppertureSymbols - 1;
      for (let i = 0; i < numberOfPreapp; ++i) {
        let idx = this._bottomPreAppertureSymbolIdx - i;
        symbolsStillInWindow.push(this._symbolData[idx].symId);
      }

      return symbolsStillInWindow;
    }

    saveInjectorsState() {
      // Jamie - temporarily removed
      // THIS MUST GO BACK IN!!!!!!!!!!!!!!!!!
      //this._dynamicInjector.saveState();
    }

    saveSymbolData() {
      this._savedSymbolData = JSON.parse(JSON.stringify(this._symbolData));
    }

    setAbortSymbols(abortSymbols) {
      this._abortSymbols = abortSymbols;
    }

    abortSpin() {
      this._aborted = true;
      this._bouncing = false;

      //let symbolsStillInWindow = this.getSymbolsStillInWindow(true);
      //this._dynamicInjector.prepareInjector(
      //  this._reelIdIndex,
      //  symbolsStillInWindow,
      //  this._nudgeReel,
      //  this._postAppertureSymbolIdx
      //);

      for (let i = 0; i < this._symbolData.length; ++i) {
        this._symbolData[i].overlayData = {};
      }

      this.literalReelPosition = 0;
      this.oldLiteralReelPosition = 0;
      this._currentSymbolOffset = 0;

      this.updateSymbolPositions();
      this.stateMachine.switchState("IDLE");
    }

    setMinSymbolSpacingScale(scale, postOffset) {
      this._minSymbolSpacing = this._symbolSpacingDefault * scale;
      this._postOffset = postOffset;
      this.refreshPos();
    }

    setTempReelBand(reelBand, startingSymbols) {
      this._tempReelBand = reelBand;
      this._tempReelBandIndex = this._totalAppertureSize;

      for (let i = 0; i < this._totalAppertureSize; ++i) {
        this._mainBandBackup.push(this._symbolData[i].symId);
        if (i < startingSymbols.length) {
          this._symbolData[i].symId = startingSymbols[i];
        } else {
          this._symbolData[i].symId = reelBand[i];
        }
      }
      this.refreshPos();
    }

    // Must be called before stop is called on slot machine
    setTempReelBandLandSymbols(landSymbols) {
      this._tempReelBandLandSymbols = landSymbols;
    }

    insertTempReelBandLandSymbols(symsToSpin) {
      let reversedLandingSymbols = this._tempReelBandLandSymbols
        .slice()
        .reverse();

      for (let i = 0; i < reversedLandingSymbols.length; i++) {
        let symbolReelBandIndex =
          this._tempReelBandStartingIndex + symsToSpin + i;
        let index = symbolReelBandIndex + 1;
        let length = this._tempReelBand.length;
        let wrappedIndex = index % length;
        if (wrappedIndex < 0) {
          wrappedIndex += length;
        }
        this._tempReelBand[wrappedIndex] = reversedLandingSymbols[i];
      }
    }

    clearTempReelBand() {
      this._tempReelBand = [];
      this._tempReelBandIndex = 0;
      this._tempReelBandLandSymbols = [];
      this._mainBandBackup = [];
    }

    customEaseIn(t, strength) {
      strength = this.clamp(strength, 1, 10);
      t = this.clamp(t, 0, 1);
      let adjustedT = Math.pow(t, strength);
      return adjustedT;
    }

    customEaseOut(t, strength) {
      strength = this.clamp(strength, 1, 10);
      t = this.clamp(t, 0, 1);
      let adjustedT = 1 - Math.pow(1 - t, strength);
      return adjustedT;
    }

    nudgeEasing(t) {
      if ((t /= 1) < 1 / 2.75) {
        return 1 * (7.5625 * t * t);
      } else if (t < 2 / 2.75) {
        return 1 * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75);
      } else if (t < 2.5 / 2.75) {
        return 1 * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375);
      } else {
        return 1 * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375);
      }
    }
  }
  module.exports = function (
    reelId,
    maxAppertureHeight,
    symbolSpacing,
    reservedSpace,
    numPreapp,
    numPostapp,
    nudgeReel
  ) {
    return new DynamicReelSpinnerData(
      reelId,
      maxAppertureHeight,
      symbolSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      nudgeReel
    );
  };
})();
